<template>
  <div class="overall-priceAd" style="position: fixed"
    v-stat:show="{action: 'hall_price_card_show', extend:{ hotspotId, seriesId, specId }}">
    <div class="overall-priceAd-lightblue">
      <div class="overall-priceAd-top">
        <div class="overall-priceAd-baseName">
          <span class="overall-priceAd-tag red"></span>
          <p>{{ vInnerText }}</p>
        </div>
      </div>
      <div class="overall-priceAd-baseBottom">
        <div class="overall-priceAd-bottomLeft">
          <Score v-if="score > 0" :score="score" />
          <!-- <div
            v-if="vDownPrice > 0"
            class="overall-priceAd-baseSales"
          >
            <em>优惠</em>
            <i></i>
            <span>{{ vDownPrice }}</span>
            <em>{{ vUnit }}</em>
          </div>-->
          <div v-if="dealerNewPrice > 0" class="overall-priceAd-price">
            <p>
              <em>本店价</em>
              <span>{{ formatPrice(dealerNewPrice) }}</span>
              <i>万</i>
              <del>{{ formatPrice(maxOriginalPrice) }}万</del>
            </p>
          </div>
        </div>
        <div class="overall-priceAd-baseOpar">
          <!-- <div
            @touchend="funShowEvent"
            @click="funShowEvent"
            class="overall-priceAd-details"
            :class="{ current: funShow }"
          >
            <p>
              <span>细节</span>
              <em></em>
            </p>
          </div>-->
          <div class="overall-priceAd-btns">
            <a v-if="facRebateAmount" v-show="!phoneCallStatus" href="javascript:void(0);"
              class="overall-priceAd-baseBtn orange" @click="gotoCPS" @touchend="gotoCPS">
              <span>领{{ facRebateAmount }}元现金</span>
            </a>
            <a href="javascript:void(0);" class="overall-priceAd-baseBtn blue" v-stat:show="{
              action: 'arhall_morexunjia_show',
              extend: { hotspotId, seriesId, specId },
            }" @click="openLayerPrice" @touchend="openLayerPrice">
              <span v-if="phoneCallStatus">预约试驾</span>
              <span v-else>询底价</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <Detail :visible="true" :seriesId="seriesId" :specId="specId" :has3d="has3d" :sceneName="sceneName"
      class="overall-priceAd-fun flipInX" />
  </div>
</template>
<script>
import layManager from '@/services/layer.manager';
import Score from './Score.vue';
import { mapGetters } from 'vuex';
import Detail from './Detail';
import {
  generateIdProxy,
  actionProxy,
} from '@/services/socketIO/user.action.interceptor';
import pvtrack from '@/services/pvtrack.service';
import { panoTagZIndexManager } from '@/services/krpano/panoTagZIndexManager';
export default {
  components: {
    Score,
    Detail,
  },
  data () {
    return {
      vInnerText: null,
      vUnit: '',
      vDownPrice: 0, //直降价格
      //  funShow: false, //详细配置隐藏
      funAnimation: false, //详细配置动效class控制
      distance: 0,
      scale: 1,
      translateX: 0,
      translateY: 0,
    };
  },
  props: {
    hotspotId: { type: [Number, String], default: 0 },
    seriesId: { type: Number, default: 0 },
    seriesName: { type: String, default: '' },
    specId: { type: Number, default: 0 },
    specName: { type: String, default: '' },
    downPrice: { type: Number, default: 0 },
    dealerNewPrice: { type: Number, default: 0 },
    maxOriginalPrice: { type: Number, default: 0 },
    score: { type: Number, default: 0 },
    salesInfo: { type: String, default: '' },
    has3d: { type: Boolean, default: false },
    sceneName: { type: String, default: '' },
    facRebateAmount: { type: Number, default: 0 },
    jumpUrl: { type: String, default: '' },
    position: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  computed: {
    ...mapGetters({
      phoneCallStatus: 'phoneCall/phoneCallStatus',
      isSHowSmartGuide:'isSHowSmartGuide',
    }),
    entry_id: function () {
      return (
        'ext_jump_series__' +
        this.seriesId +
        ',ext_entry_series__' +
        this.seriesId +
        ',flbnb__6839704'
      );
    },
  },
  created: generateIdProxy(
    function () {
      if (this.downPrice || this.downPrice > 0) {
        if (this.downPrice >= 10000) {
          this.vDownPrice = (this.downPrice / 10000).toFixed(2);
          this.vUnit = '万';
        } else {
          this.vDownPrice = this.downPrice;
          this.vUnit = '元';
        }
      }
      if (this.salesInfo !== null && this.salesInfo !== '') {
        //优先提取促销信息
        this.vInnerText = this.salesInfo;
      } else {
        //其次提取车系车型名称
        this.vInnerText = this.seriesName + ' ' + this.specName;
      }
    },
    function () {
      return 'price_card_' + this.hotspotId;
    },
  ),
  mounted () {
    const panoComponent = this.$panoComponent;
    if (panoComponent) {
      panoTagZIndexManager.register(this.$el, this.position);
      panoTagZIndexManager.setPanoComponent(panoComponent);
    }
  },
  methods: {
    formatPrice (price) {
      return (price / 10000).toFixed(2);
    },
    gotoCPS () {
      pvtrack.pvTrackLogger({
        action: 'cps_factory_entry_page_click',
        basic: { type: 'click' },
        extebd: { entry_id: this.entry_id },
      });
      // 如果是导览期间，不可点击
      if (this.isSHowSmartGuide) {
        return;
      }
      var linkUrl =
        this.jumpUrl +
        '&ext_jump_series=' +
        this.seriesId +
        '&ext_entry_series=' +
        this.seriesId +
        '&siteId=748&productid=1600&flbnb=6839704';
      window.location.href = linkUrl;
    },
    openLayerPrice () {
      if (this.isSHowSmartGuide) {
        return;
      }
      setTimeout(() => {
        pvtrack.pvTrackLogger({
          action: 'arhall_morexunjia_click',
          basic: { type: 'click' },
        });
        layManager.price(this.seriesId, this.specId, 'showcard', 1);
      }, 100);
    },
    // funShowEvent () {
    //   if (this.animating) {
    //     return;
    //   }
    //   if (this.funShow) {
    //     //状态为显示，点击隐藏
    //     this.detailAnimation(false, 350);
    //   } else {
    //     //状态为隐藏，点击显示
    //     this.detailAnimation(true, 100);
    //   }
    // },
    detailAnimation: actionProxy(
      'detailAnimation',
      function (funShow, duration) {
        this.funAnimation = funShow;
        this.animating = true;
        setTimeout(() => {
          this.funShow = funShow;
          this.animating = false;
        }, duration);
      },
    ),
  },
};
</script>
<style lang="scss">
.overall-priceAd {
  width: ptrd(444px);
  user-select: none;
  touch-action: none;

  .overall-priceAd-white {
    border-radius: ptrd(12px);
    background: rgba(255, 255, 255, 0.93);
  }

  .overall-priceAd-lightblue {
    border-radius: ptrd(24);
    // background-image: linear-gradient(
    //   rgba(255, 255, 255, 0.96) 33%,
    //   rgba(#d0e0ff, 0.96)
    // );
    background-image: linear-gradient(180deg,
        rgba(255, 255, 255, 0.96) 9%,
        rgba(255, 255, 255, 0.86) 97%);
    position: relative;
    z-index: 2;
    overflow: hidden;

    &::after {
      position: absolute;
      content: '';
      width: 100%;
      height: ptrd(62px);
      background: url($img + 'infoboard-bg.png') no-repeat center bottom;
      background-size: 100% ptrd(62px);
      bottom: 1px;
      left: 0;
    }
  }

  &-top {
    padding: ptrd(16) ptrd(20px) 0;
    position: relative;
    z-index: 2;
  }

  &-baseName {
    display: flex;
    align-items: center;

    p {
      flex: 1;
      width: 1%;
      @extend %ellipsis-basic;
      font-size: ptrd(24px);
      line-height: ptrd(32);
      font-weight: bold;
      margin-left: ptrd(6px);
    }
  }

  &-tag {
    flex-shrink: 0;
    // border-radius: ptrd(4px);
    font-size: ptrd(20px);
    // padding: ptrd(4px);
    line-height: ptrd(24px);
    color: #fff;

    // position: absolute;
    // left: 0;
    // top: 0;
    &.red {
      //background-image: linear-gradient(270deg, #ff4434 0%, #ff5b4c 100%);
      width: ptrd(32);
      height: ptrd(32px);
      background: url($img + 'cu-icon.png') no-repeat center center;
      background-size: 100%;
    }
  }

  &-baseBottom {
    padding: 0 ptrd(20px) ptrd(16);
    position: relative;
    z-index: 2;
  }

  &-bottomLeft {
    display: flex;
    align-items: center;
    min-height: ptrd(12px);
    margin-top: ptrd(4px);
  }

  &-baseSales {
    margin-left: ptrd(16px);
    font-size: 0;
    line-height: ptrd(36px);

    em,
    i,
    span {
      display: inline-block;
      vertical-align: middle;
      font-weight: bold;
    }

    em {
      font-size: ptrd(24px);
    }

    i {
      width: ptrd(24px);
      height: ptrd(24px);
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhklEQVRIS7WVPUvDUBSG3xNbsA5ORXEQl/4A2yRDnYTi5Ca4OTnrUlp7Mwgu2pSWCoKrk5vg5CQIbgGbVH9AFyk4SPcK1RxpErCFftzi7Z1Pnue9JycnhDkfmjMf8gL3bAmryxwEareBrcuuTDh5QbO2AXxFzEUgU3hXK3gpmyAtDBTzGWmroVbg2rsgP7pxDNBPHtQKGuVDaFr4DnyfYFo3agWuLf6AxDBKFbUCz64PAXWRVytwy7dDQMM6UCywH8ED340pdlQL3gAOp4iIoYtN1YKPPjqA9mfJFGuqBT8ROrgDDLHwP4FnnwNkgaO2jKMRfDAuYIjTUSXjd5FrXwE4lkkJwjV0cTSboF1P4LP3BObsRAmRg5V4Duv5kdt18jZ1a0nQtwNGaqSE0ALHsjAKnfEdnNYDr54C9xyAk8Ol1AHFs9DzrUkIuf9Bs5qF7z8BnAhh1IWm5ZApOtPyyQn6FK+yB/BdJNiHXrqfBg/neZbzWt0OytPFZ9nHZhPIUgfq5i74BXWMaRn9H36nAAAAAElFTkSuQmCC) no-repeat center center;
      background-size: 100%;
    }

    span {
      font-size: ptrd(28px);
      color: #00cc88;
      @extend %font-number;

      &~em {
        color: #00cc88;
      }
    }
  }

  &-price {
    margin-left: ptrd(8px);
    height: ptrd(36px);
    line-height: ptrd(36);
    display: flex;
    align-items: center;

    p {
      height: ptrd(24px);
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
    }

    em {
      font-size: ptrd(18);
      // font-weight: bold;
    }

    span {
      @extend %font-number;
      font-size: ptrd(22);
      color: #f96603;
      margin-left: ptrd(6);
      position: relative;
      top: ptrd(-1);
    }

    i {
      font-size: ptrd(18);
      color: #f96603;
      font-weight: bold;
    }

    del {
      color: #adb1b8;
      margin-left: ptrd(6);
      font-size: ptrd(16);
      position: relative;
      // top: ptrd(2px);
    }
  }

  &-baseOpar {
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    margin-top: ptrd(4px);
  }

  &-details {
    flex-shrink: 0;
    font-size: 0;
    line-height: ptrd(54px);
    margin-right: ptrd(16px);
    height: ptrd(54px);

    &.current {
      color: #206cfe;

      em {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAv0lEQVQYV2NkwAIsS19OAQkf7xbPQZdmRBcwK3q94dUvYX+QuBjb242n+kQDkNWgaLAsfdb+/LtEBbICSc4XHce7pSphYnANdqVP4h5/l1z4nwHVUkaG/wyynM/jD3XLLAJpAss6ljw2f/hT8vi//0wYTgTJMzH++y/P/txyf4/sSUbXskdS979LPPrzn4UZWwDAxFgY//xV5Hwhx6hd8Pn11z/cIvgUw+S4Wb69ZdQt/PT4828eGWI08LJ+fgwAYLBArPKSTa0AAAAASUVORK5CYII=);
      }
    }

    span,
    em {
      display: inline-block;
      vertical-align: middle;
    }

    span {
      font-size: ptrd(22px);
    }

    em {
      width: ptrd(12px);
      height: ptrd(8px);
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAwklEQVQYV2Ns6lnUzMDwr4qBgYGJAT/4x8jI0M7Y3Ltgyv//DNkEFIOlGRkZJzP29a3i/PLv+14Ghv+W+DUxHudh4nRmBCnq6Vkm8o3x93GG//9VsGpiZLzD9Z/VsqQk6g1YAwi09y1W+f3/H0iTCIomRsY3rIxMlpVFsXfAzkKWbOtfaPn3H8Pe////c0Ld/J2ZicG5qjD+OEwdigaQYHP/oqD/f/+tBmtgZgqtLYxbh2wohgaIpsUOILq2MPYAup8AB4I/T0JRcxQAAAAASUVORK5CYII=) no-repeat center center;
      background-size: 100%;
      margin-left: ptrd(6px);
    }
  }

  &-btns {
    // flex: 1;
    // width: 1%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-baseBtn {
    height: ptrd(54px);
    line-height: ptrd(54px);
    font-size: ptrd(22px);
    font-weight: bold;
    border-radius: ptrd(8px);
    text-align: center;
    flex: 1;

    &+.overall-priceAd-baseBtn {
      margin-left: ptrd(10px);
    }

    &.blue {
      background-image: linear-gradient(270deg, #206cfe 2%, #4c88ff 100%);
      color: #fff;
      padding: 0 ptrd(20px);
    }

    &.orange {
      background: #fff7f2;
      border: 1px solid #ffcdad;
      box-sizing: border-box;
      color: #ff6600;
      padding: 0 ptrd(10px);
    }

    &:only-child {
      width: ptrd(260px);
    }
  }

  &-fun {
    padding-top: ptrd(24);
    height: ptrd(78);
    // background: #e6e9f0;
    // border-radius: 0 0 ptrd(12px) ptrd(12px);
    transform-style: preserve-3d;
    perspective: 400px;
    margin-top: ptrd(-24);
    // background: rgba(0, 0, 0, 0.7);
    background-image: linear-gradient(180deg,
        rgba(255, 255, 255, 0),
        rgba(0, 0, 0, 0.7) 0.6rem);
    // border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 0 0 ptrd(24px) ptrd(24px);
    box-sizing: border-box;

    &.flipOutX {
      transform: rotate3d(1, 0, 0, 90deg);
      opacity: 0;
      transition: 0.35s;
    }

    &.flipInX {
      transform: rotate3d(1, 0, 0, 10deg);
      opacity: 1;
      transition: 0.35s;
    }

    ul {
      height: ptrd(52);
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-around;
      margin-top: -1px;
    }

    &-item {
      // flex: 1;
      // width: 1%;
      flex-shrink: 0;
      font-size: 0;
      text-align: center;
      color: #fff;

      &+.overall-priceAd-fun-item {
        //border-left: 1px solid rgba(#666d7f, 0.15);
      }

      em,
      span {
        display: inline-block;
        vertical-align: middle;
      }

      em {
        width: ptrd(24);
        height: ptrd(24);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100%;

        &.overall-priceAd-out {
          width: ptrd(28);
          height: ptrd(28);
        }
      }

      span {
        font-size: ptrd(22);
        line-height: ptrd(26);
        margin-left: ptrd(6px);
      }
    }
  }

  &-in {
    background-image: url($img + 'infoboard-inset.png');
  }

  &-out {
    background-image: url($img + 'infoboard-out.png');
  }

  &-pic {
    background-image: url($img + 'infoboard-pic.png');
  }

  &-setting {
    background-image: url($img + 'infoboard-setting.png');
  }
}
</style>
